import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  imports: [RouterModule],
  templateUrl: './home.component.html',
  standalone: true,
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  constructor(private router: Router,private auth: AuthService) {}

  // Navigate to Apply page
  goToApply() {
    this.router.navigate(['/apply']);
  }

  // Navigate to Pay Rent page
  goToPay() {
    this.router.navigate(['/pay']);
  }

  async goToPortal() {
    const user = this.auth.currentUser;

    if (!user) {
      await this.router.navigate(['/login']);
      return;
    }

    const role = await this.auth.getUserRole();
    if (role === 'tenant') {
      await this.router.navigate(['/tenant']);
    } else if (role === 'admin') {
      await this.router.navigate(['/admin']);
    } else {
      await this.router.navigate(['/login']);
    }
  }

}
